<template>
    <div class="wrap">
        <div class="container">
            <h3 class="personal_titile">添加地址</h3>
            <div class="adddz chardz">
                <form @submit="saveAddress">
                    <div class="address_require">
                        <label>姓名<span>*</span></label>
                        <input type="text" maxlength="50" value="" v-model="address_info.name" required>
                    </div>
                    <div class="address_require">
                        <label>邮箱<span>*</span></label>
                        <input type="email" maxlength="50" value="" v-model="address_info.email" required>
                    </div>
                    <van-row type="flex" align="center" justify="space-between">
                        <van-col span="11" class="address_require">
                            <label>省份<span>*</span></label>
                            <input type="text" readonly value="" @click="showCountryPicker = true" v-model="address_info.country_name">
                            <van-popup v-model="showCountryPicker" position="bottom">
                                <van-picker :default-index="country_key" show-toolbar value-key="name" :columns="countryPicker" @cancel="showCountryPicker = false" @confirm="changeCity($event,'country')" />
                            </van-popup>
                        </van-col>
                    </van-row>
                    <van-row type="flex" align="center" justify="space-between">
                        <van-col span="11" class="address_require">
                            <label>城市<span>*</span></label>
                            <input type="text" readonly value="" @click="showStatePicker = true" v-model="address_info.province_name">
                            <van-popup v-model="showStatePicker" position="bottom">
                                <van-picker :default-index="province_key" show-toolbar value-key="name" :columns="statePicker" @cancel="showStatePicker = false" @confirm="changeCity($event,'state')" />
                            </van-popup>
                        </van-col>
                        <van-col span="11" class="address_require">
                            <label>区县<span>*</span></label>
                            <input type="text" readonly value="" @click="showCityPicker = true" v-model="address_info.city_name">
                            <van-popup v-model="showCityPicker" position="bottom">
                                <van-picker :default-index="city_key" value-key="name" show-toolbar :columns="cityPicker" @cancel="showCityPicker = false" @confirm="changeCity($event,'city')" />
                            </van-popup>
                        </van-col>
                    </van-row>
                    <div class="address_require">
                      <label>详细地址<span>*</span></label>
                      <input type="text" value="" v-model="address_info.address" required>
                  </div>
                    <van-row type="flex" align="center" justify="space-between">
                        <van-col span="11" class="address_require">
                            <label>邮政编码<span>*</span></label>
                            <input type="text" value="" v-model="address_info.postal_code" required>
                        </van-col>
                        <van-col span="11" class="address_require">
                            <label>手机号码<span>*</span></label>
                            <input type="text" value="" v-model="address_info.tel">
                        </van-col>
                    </van-row>
                    <br/>
                    <br/>
                    <van-row type="flex" align="center" justify="center">
                        <van-col span="20">
                            <van-button block type="primary" >保存</van-button>
                        </van-col>
                    </van-row>
                </form>
            </div>

        </div>
    </div>
</template>
<style>

</style>
<script>
// import { areaList } from '@vant/area-data';
    export default {
        components: {},
        created() {
            this.id = this.$route.params.id;
            this.getData();
        },
        data() {
            return {
              // areaList,
                id: 0,
                address_info : {},
                countryPicker:[{id:0,name:'请选择'}],
                statePicker: [{id:0,name:'请选择'}],
                cityPicker:[{id:0,name:'请选择'}],
                showCountryPicker: false,
                showStatePicker: false,
                showCityPicker: false,
                country_key: 0,
                province_key: 0,
                city_key: 0,
                country:'',


                countryName: '请选择',
                stateName: '请选择',
                cityName: '请选择',
                country_id:0,
                province_id: 0,
                city_id: 0,
                email : '',
                full_name: '',
                postal_code: '',
                tel: '',
                address_line: '',
            }
        },
        methods: {
            getData(){
                var url = 'api/useraddress/Detail'
                var data = {id:0};
                var _self = this;

                this.POST(url,data,function (ret) {
                    if(ret.code === 0){
                        _self.countryPicker    = [{id:0,name:'请选择'}]
                        _self.countryPicker    = _self.countryPicker.concat(ret.data.country);
                        _self.statePicker   = [{id:0,name:'请选择-'}]
                        _self.statePicker   = _self.statePicker.concat(ret.data.province);
                        _self.cityPicker    = [{id:0,name:'请选择'}]
                        _self.cityPicker    = _self.cityPicker.concat(ret.data.city);
                        _self.country_key  = ret.data.country_key;
                        _self.province_key  = ret.data.province_key;
                        _self.city_key      = ret.data.city_key;                        
                        _self.address_info.country_name = '请选择';
                        _self.address_info.country_id = 0;                
                        _self.address_info.province_name = '请选择';
                        _self.address_info.province_id = 0;
                        _self.address_info.city_name = '请选择';
                        _self.address_info.city_id = 0
                    }
                })
            },
            changeCity(e,type){
                var _self = this;
                var url = '';
                var data = '';
                if(type === 'country'){
                    this.address_info.country_name = e.name;
                    this.address_info.country = e.id;
                    this.showCountryPicker = false;
                    if(e.id > 0) {
                        url = 'api/region/index';
                        data = {pid: e.id};
                        this.POST(url, data, function (ret) {
                            if (ret.code === 0) {
                                _self.province_key   = 0
                                _self.statePicker = [{id:0,name:'请选择'}]
                                _self.statePicker = _self.statePicker.concat(ret.data);
                                _self.city_key   = 0
                                _self.cityPicker = [{id:0,name:'请选择'}]
                                _self.cityPicker = _self.cityPicker.concat(ret.data);
                            }
                        })
                    }else{
                        _self.city_key   = 0
                        _self.cityPicker = [{id:0,name:'请选择'}];
                    }
                    _self.address_info.province = 0;
                    _self.address_info.province_name = '请选择';
                    _self.address_info.city = 0;
                    _self.address_info.city_name = '请选择';
                }else if(type === 'state'){
                    this.address_info.province_name = e.name;
                    this.address_info.province = e.id;
                    this.showStatePicker = false;
                    if(e.id > 0) {
                        url = 'api/region/index';
                        data = {pid: e.id};
                        this.POST(url, data, function (ret) {
                            if (ret.code === 0) {
                                _self.city_key   = 0
                                _self.cityPicker = [{id:0,name:'请选择'}]
                                _self.cityPicker = _self.cityPicker.concat(ret.data);
                            }
                        })
                    }else{
                        _self.city_key   = 0
                        _self.cityPicker = [{id:0,name:'请选择'}];
                    }
                    _self.address_info.city = 0;
                    _self.address_info.city_name = '请选择';
                }else if(type === 'city'){
                    this.address_info.city_name = e.name;
                    this.address_info.city = e.id;
                    this.showCityPicker = false;
                }
            },
            saveAddress(){
                if(this.address_info.country == 0){
                    this.$toast('请选择省份');
                    return false;
                }
                if(this.address_info.province == 0){
                    this.$toast('请选择城市');
                    return false;
                }
                if(this.address_info.city == 0){
                    this.$toast('请选择区县');
                    return false;
                }

                var url = 'api/useraddress/save';
                var _self = this;
                this.POST(url,this.address_info,function (ret) {
                    if(ret.code === 0){
                        // _self.$router.go(-1)
                        _self.$router.push('Address');
                        // _self.$router.replace({path:localStorage.getItem('selectaddress_path')})
                    }else{
                        _self.$toast(ret.msg)
                    }
                })
            }
        },
    }
</script>